// extracted by mini-css-extract-plugin
export default {"btnpwd":"_621485271d"};